module.exports = __webpack_public_path__ + "img/2020_12_01_oct.fbf777ee.jpg";